/**
 * Ensures a URL has a protocol (https:// by default)
 * @param url The URL to format
 * @param defaultProtocol The default protocol to use if none is present
 * @returns A properly formatted URL with protocol
 */
export const ensureUrlProtocol = (url: string, defaultProtocol: string = 'https://'): string => {
  if (!url) return '';
  
  // Check if the URL already has a protocol
  if (/^https?:\/\//i.test(url)) {
    return url;
  }
  
  // Add the default protocol
  return `${defaultProtocol}${url}`;
};

/**
 * Creates a safe URL for external links
 * @param url The URL to format
 * @returns A properly formatted URL with protocol
 */
export const createSafeExternalUrl = (url: string): string => {
  if (!url) return '#';
  
  // Ensure the URL has a protocol
  const formattedUrl = ensureUrlProtocol(url);
  
  // Additional safety checks could be added here
  
  return formattedUrl;
};
